import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Select,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import PropTypes from 'prop-types';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from '../../../utils/constants';
import { validateAlphaPlus, validateAlphanumeric } from '../../../utils/commonHelpers';
import { toast } from 'react-toastify';

const EditDialog = ({ data, onClose, onSubmit }) => {
    const [groupName, setGroupName] = useState(data.name);
    const [description, setDescription] = useState(data.description);
    // const [isParent, setIsParent] = useState(props.data.parent === 0 ? true : false);
    const [parentId, setParentId] = useState(data.parent);

    const [groupsData, setGroupsData] = useState('');

    useEffect(() => {
        getGroups();
    }, []);

    const getGroups = () => {
        ApiHelper.get(API_URL.MANAGEMENT_GROUPS)
            .then((res) => {
                setGroupsData(res.data.groups_results);
            })
            .catch((err) => console.log(err));
    };

    // const handleChangeIsParent = (e) => {
    //     setIsParent(e.target.checked);
    // };

    const handleChangeParentId = (e) => {
        setParentId(Number(e.target.value));
    };

    const handleSubmit = () => {
        if (!validateAlphanumeric(groupName)) {
            toast.info('The group name must be alphanumeric');
            return;
        }
        if (!validateAlphaPlus(description)) {
            toast.info('The description must be alphanumeric');
            return;
        }
        onSubmit({ groupName, description, parentId });
    };

    if (!groupsData) {
        return null;
    } else {
        return (
            <Dialog open={true} onClose={onClose}>
                <DialogTitle sx={{ fontSize: '16px' }}>Edit Group</DialogTitle>
                <DialogContent sx={{ minWidth: '500px' }}>
                    <Box sx={{ mb: 3, mt: 3 }}>
                        <TextField
                            sx={{ width: '100%' }}
                            label="Group Name"
                            onChange={(e) => setGroupName(e.target.value)}
                            value={groupName}
                            inputProps={{
                                maxLength: 30
                            }}
                        />
                    </Box>
                    <Box sx={{ mb: 3, mt: 3 }}>
                        <TextField
                            sx={{ width: '100%' }}
                            label="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            inputProps={{
                                maxLength: 50
                            }}
                        />
                    </Box>
                    <Box>
                        {/*<FormControlLabel*/}
                        {/*    control={<Checkbox checked={isParent} onChange={handleChangeIsParent} color="primary" />}*/}
                        {/*    label="Is Parent"*/}
                        {/*/>*/}
                        {/*{!isParent && (*/}
                        <FormControl sx={{ width: '100%', mt: 2 }}>
                            <InputLabel>Parent Group</InputLabel>
                            <Select label="Parent Group" onChange={handleChangeParentId} value={parentId}>
                                {/*<MenuItem value={0}>(root)</MenuItem>*/}
                                {groupsData
                                    .filter((node) => node.id !== data.id)
                                    .map((node) => (
                                        <MenuItem key={node.id} value={node.id}>
                                            {node.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        {/*)}*/}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button disabled={groupName === ''} onClick={handleSubmit}>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
};

EditDialog.propTypes = {
    data: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
};

export default EditDialog;
